import * as Sentry from '@sentry/react'

const isProd = import.meta.env.VITE_APP_MODE === 'production'

/**
 * Sends exception to Sentry.
 * @param error — any occurred error (Error, string, object, etc.)
 * @param context — additional meta information
 */
export function captureException(error: unknown, context?: Record<string, unknown>): void {
    if (isProd) {
        Sentry.captureException(error, { extra: context })
    } else {     
        console.error('[Sentry-Dev] captureException:', error, context)
    }
}

/**
 * Adds breadcrumbs to the current Sentry session.
 * This function helpful to use for logging chains of events
 * or API call to determine the exact place of the error.
 * 
 * More about bradcrumbs: https://develop.sentry.dev/sdk/data-model/event-payloads/breadcrumbs/#breadcrumb-types
 */
export function addBreadcrumb(breadcrumb: Sentry.Breadcrumb): void {
    if (isProd) {
        Sentry.addBreadcrumb(breadcrumb)
    } else {
    // eslint-disable-next-line no-console
        console.debug(
            '[Sentry-Dev] breadcrumb:',
            breadcrumb?.message,
            breadcrumb?.data,
        )
    }
}

export function setSentryUser(userId: string) {
    if (isProd) {
        Sentry.setUser({ id: userId })
    } else {
        // eslint-disable-next-line no-console
        console.debug('[Sentry-Dev] user:', userId)
    }
}

export { Sentry }
